// Inner weather dimension bucket helpers

// 3-way bucket for quote lookup: low (0-33), mid (34-66), high (67-100)
export const scoreToBucket = (score: number): "low" | "mid" | "high" => {
  if (score <= 33) return "low";
  if (score <= 66) return "mid";
  return "high";
};

// Build bucket key from three dimension scores
export const getBucketKey = (a: number, b: number, c: number): string => {
  return `${scoreToBucket(a)}-${scoreToBucket(b)}-${scoreToBucket(c)}`;
};
